module.exports = __webpack_public_path__ + "img/1.ef209726.jpg";